import { render, staticRenderFns } from "./DataCorrectionTaskLevel1.vue?vue&type=template&id=044254bc&scoped=true&"
import script from "./DataCorrectionTaskLevel1.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionTaskLevel1.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionTaskLevel1.vue?vue&type=style&index=0&id=044254bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044254bc",
  null
  
)

export default component.exports